import { connect } from 'react-redux'
import WordBankSlideEditDialog from './edit-dialog.jsx'
import {
  deleteSlide,
  updateSlide
} from '../../../../stores/presentation/presentation.actions'
import {
  getDeleteSlideRequest,
  getUpdateSlideRequest,
  getSlide
} from '../../../../stores/presentation/presentation.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const editSlideDialog = getEditSlideDialog(state)
  const slide = getSlide(state, editSlideDialog.slideId)
  if (!slide) return { modalOpened: false }
  const updateSlideRequest = getUpdateSlideRequest(state, slide.id)
  const deleteSlideRequest = getDeleteSlideRequest(state, slide.id)
  return {
    updating: updateSlideRequest.pending,
    deleting: deleteSlideRequest.pending,
    modalOpened: editSlideDialog.opened && editSlideDialog.type === 'WordBank',
    title: slide.title,
    bank: slide.bank,
    id: slide.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onClose: () => dispatch(closeEditSlideDialog()),
  onSubmit: values =>
    dispatch(
      updateSlide(stateProps.id, 'WordBank', {
        title: values.title,
        bank: values.bank
      })
    ).catch(errorHandler),
  onDelete: () => dispatch(deleteSlide(stateProps.id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WordBankSlideEditDialog)
